export const blockIconsMapsLocalFloristNew = (
	<span className='material-symbols-outlined'>local_florist</span>
);
